import services from 'api/services';
import { logError } from 'util/errors';

import {
  LOAD_PAYMENTS_REQUEST,
  LOAD_PAYMENTS_SUCCESS,
  LOAD_PAYMENTS_FAILURE,
  CREATE_PAYMENTS_REQUEST,
  CREATE_PAYMENTS_SUCCESS,
  CREATE_PAYMENTS_FAILURE,
} from './constants';

const { PaymentService } = services;

export const getPayments = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_PAYMENTS_REQUEST });
    const payments = await PaymentService.getPayments();
    dispatch({ type: LOAD_PAYMENTS_SUCCESS, data: payments });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_PAYMENTS_FAILURE, error: ex.message });
  }
};

export const createPayment = (body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PAYMENTS_REQUEST });
    const payment = await PaymentService.createPayment(body);
    dispatch({ type: CREATE_PAYMENTS_SUCCESS, data: payment });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_PAYMENTS_FAILURE, error: ex.message });
  }
};
